import React, { Component } from 'react';

import Loading from './Loading';

import * as constants from '../../config/constants/AppConstants';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

class EB05PrintContent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            Action:{
                PreviewFile: {}
            },
            Datasets: {},
            loading: false
        };
        this.updateState = this.setState.bind(this);
    }

    loadDatasets = async () => {
        let { id } = this.props;

        let sets = [
            { key: "satisfaction_assessment_eb_05", filter: [{ field: "training_details_enterprise_eb_03_id", value: id }] }
        ];

        await Actions.loadDatasets(this.updateState, sets);

        this.setState({loading: false});        
    }    

    initialize = async () => { await this.loadDatasets(); }

    componentDidMount = async () => { await this.initialize(); }

    componentDidUpdate = async () => { }        

    render = () => {

        let { Action } = this.state;

        const { id } = this.props;

        let { Datasets } = this.state;
        let ds = Datasets;   

        let eb = ds?.satisfaction_assessment_eb_05 || {};
        if (eb[0]) { eb = eb[0]; }
        eb = Object.fromEntries(Object.entries(eb).map(([key, value]) => [key, util.renderText(value)]));

        let question = {
            "1" : "๑. หลักสูตรได้ชี้แจงรายละเอียดและรูปแบบเกี่ยวกับการอบรมตามแนวทางของ EEC Model Type B แก่สถานประกอบการ", 
            "2" : "๒. สถานประกอบการได้ร่วมออกแบบหลักสูตร หรือเสนอแนะรายละเอียด เนื้อหา และทักษะที่ต้องการให้บุคลากรได้รับจากการอบรมแก่หลักสูตร", 
            "3" : "๓. หลักสูตรได้มีการคัดกรองบุคลากรที่มีคุณสมบัติเหมาะสมให้แก่สถานประกอบการ เพื่อคัดเลือกให้เข้าอบรมในหลักสูตร", 
            "4" : "๔. หลักสูตรได้แจ้งรายละเอียดและวัตถุประสงค์เกี่ยวกับการอบรมทีมวิทยากร และทักษะที่บุคลากรจะได้รับภายหลังเสร็จสิ้นการอบรมแก่สถานประกอบการ'", 
            "5" : "๕. แนวทางการฝึกอบรมของหลักสูตรมีความน่าเชื่อถือ และสามารถเพิ่มทักษะให้กับบุคลากรของสถานประกอบการได้จริง", 
            "6" : "๖. บุคลากรที่เข้าร่วมอบรมในหลักสูตรมีทักษะในการปฏิบัติงานเพิ่มขึ้น", 
            "7" : "๗. บุคลากรสามารถนำองค์ความรู้ที่ได้จากการอบรมในหลักสูตรมาประยุกต์ใช้ในการทำงานได้จริง", 
            "8" : "๘. บุคลากรที่เข้าร่วมอบรมในหลักสูตรสามารถถ่ายทอดองค์ความรู้หรือทักษะที่ได้เรียนรู้จากการอบรมแก่เพื่อนร่วมงาน อันเป็นการยกระดับคุณภาพการทำงานของสถานประกอบการ", 
            "9" : "๙. หลักสูตรมีการติดตามผลสัมฤทธิ์ของบุคลากรที่ผ่านการอบรม โดยมีการติดต่อประสานงานกับสถานประกอบการอย่างน้อย ๑ ครั้ง ภายหลังเสร็จสิ้นการฝึกอบรม", 
            "10" : "๑o. ผลลัพธ์โดยรวมของบุคลากรที่ได้รับการอบรมจากหลักสูตรตามแนวทางของ EEC Model Type B", 
        } 

        const rows_q_1 = [];

        for (let i = 1; i <= 5; i++) {
            const questionText = question[i.toString()];
            const value = eb['question_' + i];

            const row = (
                <tr key={i}>
                     <td key={'td_' + i} className="text-14px">{questionText}</td>
                        {Array(5).fill(null).map((_, j) => {
                            const index = 5 - j;
                            return (
                                <td key={j} className="text-center text-14px">
                                    {Number(value) === Number(index) ? '✔' : ''}
                                </td>
                            );
                        })}
                </tr>
            );

            rows_q_1.push(row);
        }    
        
        const rows_q_2 = [];

        for (let i = 6; i <= 10; i++) {
            const questionText = question[i.toString()];
            const value = eb['question_' + i];

            const row = (
                <tr key={i}>
                     <td key={'td_' + i} className="text-14px">{questionText}</td>
                        {Array(5).fill(null).map((_, j) => {
                            const index = 5 - j;
                            return (
                                <td key={j} className="text-center text-14px">
                                    {Number(value) === Number(index) ? '✔' : ''}
                                </td>
                            );
                        })}
                </tr>
            );

            rows_q_2.push(row);
        }               

        return this.state.loading ? (
            <Loading />
        ) : (
            <>
                <div className="print-container">
                    <div className="print-page">
         
                        <h6 className="text-end mb-4">สำนักงานคณะกรรมการนโยบายเขตพัฒนาพิเศษภาคตะวันออก (สกพอ.)</h6>
                        <h6 className="text-end mb-4">แบบฟอร์ม EB-05 แบบประเมินความพึงพอใจ</h6>

                        <h4 className="text-center">
                            <b>แบบประเมินความพึงพอใจคุณภาพของหลักสูตร (EB 05)</b>
                        </h4>

                        <p><b>คำชี้แจง : การใช้แบบประเมินความพึงพอใจคุณภาพของหลักสูตรตามแนวทาง EEC Model</b></p>
                        <p>๑. แบบประเมินนี้ใช้ประเมินความพึงพอใจคุณภาพหลักสูตรการอบรมตามแนวทาง EEC Model</p>
                        <p>๒. ผู้ประเมิน คือ สถานประกอบการที่ส่งบุคลากรเข้ารับการอบรมในหลักสูตร</p>
                        <p>๓. แบบประเมินนี้ใช้ประเมินการดำเนินงานของหลักสูตร ทั้งก่อนการอบรมและภายหลังเสร็จสิ้นการอบรม</p>

                        <p className="text-center">{'.'.repeat(100)}</p>

                        <p><b>๑. ข้อมูลทั่วไป</b></p>

                        <p className="ms-6">๑.๑ ชื่อสถานประกอบการ {util.printText(eb.enterprise_name)}</p>
                        <p className="ms-6">๑.๒ ตำแหน่งของผู้ถูกประเมิน (เช่น หัวหน้าฝ่ายบุคคล หัวหน้าช่าง ฯลฯ) {util.printText(eb.evaluator)}</p>
                        <p className="ms-6">๑.๓ ชื่อหลักสูตรที่บุคลากรเข้ารับการอบรม {util.printText(eb.course_eb_03_name)}</p>
                        <p className="ms-6">
                            ๑.๔ ระยะเวลาที่เข้าร่วม ตั้งแต่ วันที่ {util.printText(util.convertDateToTextBE(eb.training_start_date))}
                            ถึง วันที่ {util.printText(util.convertDateToTextBE(eb.training_end_date))}
                            รวมเป็นเวลาทั้งสิ้น {util.printText(util.calculateNumberOfDays(eb.training_start_date, eb.training_end_date))} วัน
                        </p>
                        <p className="ms-6">๑.๕ จำนวนบุคลากรที่เข้าร่วมอบรม {util.printText(util.formatNumber(eb.person_count))} คน</p>
                        <p className="ms-6">๑.๖ ค่าใช้จ่ายที่สถานประกอบการลงทุน (ร้อยละ ๕0) ในการอบรมครั้งนี้ (เพื่อเป็นข้อมูลในการลดหย่อนภาษี) เป็นจำนวนทั้งสิ้น {util.printText(util.formatNumber(eb.employer_investment))} บาท</p>

                        <p className="mt-4"><b>โปรดอ่านและทำเครื่องหมาย ✔ ลงในช่องที่ตรงกับความคิดเห็นของท่าน</b></p>

                        <p className="ms-6">๕ ระดับมากที่สุด หมายถึง ความพึงพอใจต่อคุณภาพของหลักสูตรในระดับมากที่สุด </p>
                        <p className="ms-6">๔ ระดับมาก หมายถึง ความพึงพอใจต่อคุณภาพของหลักสูตรในระดับมาก </p>
                        <p className="ms-6">๓ ระดับปานกลาง หมายถึง ความพึงพอใจต่อคุณภาพของหลักสูตรในระดับปานกลาง </p>
                        <p className="ms-6">๒ ระดับน้อย หมายถึง ความพึงพอใจต่อคุณภาพของหลักสูตรในระดับน้อย </p>
                        <p className="ms-6">๑ ระดับน้อยที่สุด หมายถึง ความพึงพอใจต่อคุณภาพของหลักสูตรในระดับน้อยที่สุด</p>
                       
                        <table className="print-table-border mt-2 mb-2">
                            <thead>
                                <tr>
                                    <td rowSpan="2" className="text-center text-14px"><b>รายการ</b></td>
                                    <td colSpan="5" className="text-center text-14px"><b>ระดับความพึงพอใจ</b></td>
                                </tr>
                                <tr>
                                    <td className="text-center text-14px" style={{width: '5%'}}><b>๕</b></td>
                                    <td className="text-center text-14px" style={{width: '5%'}}><b>๔</b></td>
                                    <td className="text-center text-14px" style={{width: '5%'}}><b>๓</b></td>
                                    <td className="text-center text-14px" style={{width: '5%'}}><b>๒</b></td>
                                    <td className="text-center text-14px" style={{width: '5%'}}><b>๑</b></td>
                                </tr>
                            </thead>
                            <tbody>
                                {rows_q_1}
                            </tbody>
                        </table>

                    </div>

                    <div className="print-page">

                        <table className="print-table-border mt-2 mb-2">
                            <thead>
                                <tr>
                                    <td rowSpan="2" className="text-center text-14px"><b>รายการ</b></td>
                                    <td colSpan="5" className="text-center text-14px"><b>ระดับความพึงพอใจ</b></td>
                                </tr>
                                <tr>
                                    <td className="text-center text-14px" style={{width: '5%'}}><b>๕</b></td>
                                    <td className="text-center text-14px" style={{width: '5%'}}><b>๔</b></td>
                                    <td className="text-center text-14px" style={{width: '5%'}}><b>๓</b></td>
                                    <td className="text-center text-14px" style={{width: '5%'}}><b>๒</b></td>
                                    <td className="text-center text-14px" style={{width: '5%'}}><b>๑</b></td>
                                </tr>
                            </thead>
                            <tbody>
                                {rows_q_2}
                            </tbody>
                        </table>

                        <p className="mt-2">ข้อเสนอแนะ / ข้อควรปรับปรุง</p>
                        <p>{util.printText(eb.suggestions)}</p>

                    </div>
                </div>
            </>
        )
    }

}

export default EB05PrintContent;